<template>
    <div id="outstanding-detail" style="background: #F2F2F2;">

        <v-row class="mb-2 ml-0">
            <v-icon @click="$router.go(-1)" class="mr-2">mdi-arrow-left</v-icon>
            Outstanding
            <v-icon size="16" class="ml-2">mdi-greater-than</v-icon>
            <span class="font-weight-bold ml-2">Outstanding Detail</span>
        </v-row>

        <v-row>

            <v-col cols="8" class="pr-3">
                <v-col class="pa-0" cols="12">
                    <v-card class="pa-5" height="100%" :loading="!outstanding">
                        <v-card-title class="card-title text-h5 font-weight-medium">
                            Basic Information
                            <v-spacer/><v-btn small @click="printOutstanding" class="orange darken-2" style="font-size: 14px; font-weight: bolder" title="Print Outstanding">
                            <v-icon left class="grey--text text--darken-2" style="font-size: 20px">mdi-printer</v-icon>PRINT PDF</v-btn>
                        </v-card-title>
                        <v-card-text v-if="outstanding">
                            <v-row>
                             <v-col cols="12">
                              <div class="d-flex align-center">
                                 <div>
                                   <v-avatar size="84" @click="openGallery([{path: outstanding.Customer.profileImage, type: 'IMAGE'}])" class="avatar" title="View Image">
                                    <v-icon v-if="!outstanding.Customer.profileImage" size="84" color="grey lighten-1">mdi-account-circle</v-icon>
                                    <v-img v-else :src="imgWpx(outstanding.Customer.profileImage, 200)" :alt="outstanding.Customer.name">
                                       <template v-slot:placeholder>
                                           <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                           <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                       </template>
                                    </v-img>
                                   </v-avatar>
                                 </div>
                                 <div  class="ml-4">
                                  <h3 class="text-h5 font-weight-regular black--text">{{outstanding.Customer.name}}</h3>
                                 </div>
                              </div>
                             </v-col>
                             <v-col cols="6">
                               <div class="text-uppercase">
                                 <span>Contact</span>
                                 <h3 class="text-h6 font-weight-regular black--text">{{outstanding.Customer.mobile}}</h3>
                                 <h3 v-if="outstanding.Customer.email" class="text-h6 text-capitalize font-weight-regular black--text">{{outstanding.Customer.email}}</h3>
                               </div>
                             </v-col>
                             <v-col cols="6">
                               <div class="text-uppercase">
                                city
                                <h3 class="text-h6 font-weight-regular text-capitalize black--text">{{outstanding.Customer.city}}</h3>
                               </div>
                             </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col class="pa-0 mt-6" cols="12">
                    <v-card class="pa-5">
                        <v-card-title class="card-title text-h5 font-weight-medium" style="display: block">
                            Orders
                        </v-card-title>
                        <v-card-text v-if="outstanding">
                            <v-row>
                                <v-col cols="4" class="text-uppercase">Total Orders<br><span
                                        class="text-h6 font-weight-regular black--text">{{outstanding.Orders.length}}</span></v-col>
                                <v-col cols="4" class="text-uppercase">Total Amount<br><span class="text-h6 font-weight-regular black--text">{{outstanding.Orders_aggregate.aggregate.sum.payableAmount | currencyFilter}}</span>
                                </v-col>
                                <v-col cols="4" class="text-uppercase">Paid Amount<br><span class="text-h6 font-weight-regular black--text">{{outstanding.CreditDebit_aggregate.aggregate.sum.amount | currencyFilter}}</span>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-col>


            <v-col cols="4">
                <v-card class="pa-5" height="100%">
                    <v-card-title class="card-title text-h5 font-weight-medium" style="display: block">
                        Outstanding
                    </v-card-title>
                    <v-card-text v-if="outstanding">
                        <v-row>
                             <v-col cols="12" class="text-uppercase">Total Outstanding<br>
                              <span class="text-h6 font-weight-regular black--text">
                                 ₹ {{outstanding.Orders_aggregate.aggregate.sum.payableAmount - outstanding.CreditDebit_aggregate.aggregate.sum.amount}}
                                </span>
                             </v-col>
                            <v-col cols="6" class="text-uppercase">Credit Limit<br><span class="text-h6 font-weight-regular black--text">{{outstanding.creditLimit | currencyFilter}}</span>
                            </v-col>
                            <v-col cols="6" class="text-uppercase">Available Limit<br><span class="text-h6 font-weight-regular black--text">{{outstanding.availableCredit | currencyFilter}}</span>
                            </v-col>
                            <v-col cols="12" class="text-uppercase">Due Day Limit<br><span
                                    class="text-h6 font-weight-regular black--text">{{outstanding.dueDayLimit}}</span></v-col>
                            <v-col cols="12" class="text-uppercase">Last Order On<br>
                                <span class="text-h6 font-weight-regular black--text">{{outstanding.Orders.length?moment(outstanding.Orders[0].created_at).format('DD-MM-YYYY hh:mm A'):'-'}}</span>
                            </v-col>
                            <v-col cols="12" class="red--text text-h6 font-weight-bold" v-if="outstanding.outstanding">
                                <v-icon class="mr-2" color="red">mdi-alert</v-icon>
                                {{outstanding.outstanding | currencyFilter}} is Overdue from {{outstanding.dueDayLimit}} Days
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-card class="mb-3 mt-3 pa-5">
            <v-card-title class="card-title text-h5 font-weight-medium" style="display: block">
                Detail Report
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="outstanding?outstanding.Orders:[]" @click:row="rowClick" :loading="outstanding?false:true" class="orders-table" >
                    <template v-slot:item.status="{ item }">
                        <v-icon :style="`color:${Constants.OrderStatusColor[item.Status.id]}`">mdi-checkbox-blank
                        </v-icon>
                    </template>
                    <template v-slot:item.orderType="{ item }">
                        <v-chip small label outlined :color="Constants.OrderTypeColor[item.orderType]">
                            {{item.orderType}}
                        </v-chip>
                    </template>
                    <template v-slot:item.orderNumber="{item}"><span class="text-body-2">#{{item.orderNumber}}</span></template>
                        <template v-slot:item.orderDate="{ item }" class="text-body-2">
                            <div style="padding-top: 18px; padding-bottom: 19px;">
                                {{ moment(item.created_at).format('DD-MM-YYYY hh:mm A') }}
                            </div>
                    </template>
                    <template v-slot:item.payableAmount="{ item }"><span class="text-body-2">{{ item.payableAmount | currencyFilter }}</span>
                    </template>
                    <template v-slot:item.paidAmount="{ item }"><span class="text-body-2">{{ item.CreditDebit_aggregate.aggregate.sum.amount | currencyFilter}}</span>
                    </template>
                    <template v-slot:item.dueAmount="{ item }">
                        <div class="text-body-2" v-html="dueAmountCell(item)"></div>
                    </template>
                    <template v-slot:item.totalOverdue="{item}"><span class="text-body-2"> {{item.totalOverdue | currencyFilter}}</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <download-popup :parameters="parameters" :dialog.sync="downloadDialog"></download-popup>
        <gallery id="gallery-out-detail" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"></gallery>
    </div>
</template>

<script>

    import Constants from "../../Constants/Constants";
    import moment from "moment";
    import {SUBSCRIBE_OUTSTANDING_BY_ID} from "../../graphql/subscriptions/Outstanding";
    import jsPDF from 'jspdf';
    import DownloadPopup from "./DownloadPopup";

    export default {
        name: "OutstandingDetail",
        components: {DownloadPopup},
        apollo: {
            $subscribe: {
                outstanding: {
                    query: SUBSCRIBE_OUTSTANDING_BY_ID,
                    variables() {
                        return {customerCreditId: this.$route.params.id}
                    },
                    result({data}) {
                        this.modifyOrdersArr(data.outstanding[0])
                    },
                }
            },
        },
        data() {
            return {
                Constants: Constants,
                user: JSON.parse(localStorage.user),
                moment: moment,
                outstanding: null,
                headers: [
                    {text: 'STATUS', value: 'status'}, {text: 'ORDER TYPE', value: 'orderType'},
                    {text: 'ORDER ID', value: 'orderNumber'}, {text: 'ORDER DATE', value: 'orderDate'},
                    {text: 'ORDER TOTAL', value: 'payableAmount', align: 'end'},
                    {text: 'PAID AMOUNT', value: 'paidAmount', align: 'end'},
                    {text: 'DUE AMOUNT', value: 'dueAmount', align: 'end'},
                    {text: 'TOTAL OVERDUE', value: 'totalOverdue', align: 'end'}
                ],
                loading: false,
                galleryImages: [],
                galleryIndex: null,
                parameters: null,
                downloadDialog: false
            }
        },
        methods: {
            modifyOrdersArr(data) {
                let totalOutstanding = 0, i = data.Orders.length;
                while (i--) {
                    totalOutstanding = totalOutstanding + (data.Orders[i].payableAmount - (data.Orders[i].CreditDebit_aggregate.aggregate.sum.amount || 0))
                    data.Orders[i]['totalOverdue'] = totalOutstanding
                }
                this.outstanding = JSON.parse(JSON.stringify(data))
            },
            dueAmountCell(item) {
                let dueAmount = item.payableAmount - (item.CreditDebit_aggregate.aggregate.sum.amount || 0)
                if (dueAmount > 0) return `<span class="red--text">₹ ${dueAmount} </span>`
                else if (dueAmount < 0) return `<span class="green--text">₹ ${Math.abs(dueAmount)} </span>`
                else return `<span>₹ ${dueAmount} </span>`
            },
            rowClick(row){
                this.$router.push({ path: '/orders/'+row.id})
            },
            printOutstanding(){
                this.parameters = {name:'Ledger', url:`${Constants.api_url}v1/generateLedger`, customerId:this.outstanding.Customer.id}
                this.downloadDialog = true
            },
            printPdf(){
                let headers = this.headers.map(h => ({id:'', align: "center", width:48, name:h.value, prompt:h.text}))
                let orders = this.outstanding.Orders.map(o => ({
                    orderType: o.orderType,
                    orderNumber: o.orderNumber,
                    payableAmount: o.payableAmount.toString(),
                    totalOverdue: o.totalOverdue.toString(),
                    status: o.Status.status,
                    orderDate: moment(o.created_at).format('DD-MM-YYYY hh:mm A'),
                    paidAmount: o.CreditDebit_aggregate.aggregate.sum.amount.toString(),
                    dueAmount: (o.payableAmount - (o.CreditDebit_aggregate.aggregate.sum.amount || 0)).toString()
                }))

                let doc = new jsPDF({orientation: "landscape", format:'a4'});
                doc.text(`${this.outstanding.Customer.name}`, 5, 8);
                doc.text(`${this.outstanding.Customer.mobile}`, 5, 16);
                doc.text(`${this.outstanding.Customer.email || '-'}`, 5, 24);
                doc.text(`Total Orders: ${this.outstanding.Orders.length}`, 5, 32);
                doc.text(`Total Amount: ${this.outstanding.Orders_aggregate.aggregate.sum.payableAmount}`, 5, 40);
                doc.text(`Paid Amount: ${this.outstanding.CreditDebit_aggregate.aggregate.sum.amount}`, 5, 48);
                doc.text(`Credit Limit: ${this.outstanding.creditLimit}`, 5, 56);
                doc.text(`Outanding: ${this.outstanding.Orders_aggregate.aggregate.sum.payableAmount - this.outstanding.CreditDebit_aggregate.aggregate.sum.amount}`, 5, 64);
                doc.text(`Available Limit: ${this.outstanding.availableCredit}`, 5, 72);
                doc.addImage(`${this.imgWpx(this.outstanding.Customer.profileImage, 200)}`, "JPEG", 250, 10, 30, 30);
                doc.table(1, 80, orders, headers, { fontSize: 10});
                doc.save( `oustanding_report_${this.outstanding.Customer.name}_${moment().format('DD_MMM_YYYY_HH_mm')}`);
            },
            openGallery(arr){
                this.galleryImages = arr.map(m => {return {
                    href: this.imgWpx(m.path, 900),
                    type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
                }})
                this.galleryIndex = 0
            }
        }
    }
</script>

<style scoped>
    #outstanding-detail {
        padding: 20px 30px;
    }

    /deep/.v-application .text-h5, .v-application .text-h6{
        font-family: 'Quattrocento Sans', sans-serif !important;
    }
    /deep/.v-application .text-h3, .v-application .text-h4{
        font-family: 'Quattrocento Sans', sans-serif !important;
    }

    .text-body-2{
        font-family: 'Quattrocento Sans', sans-serif !important;
    }

    .card-title {
        font-weight: 600;
        font-size: 20px;
    }
    .orders-table:hover{
        cursor: pointer;
    }
    .avatar{
        cursor: pointer;
    }
    .customer-detail-icon {
        font-size: 14px;
        margin-right: 10px;
    }

    .customer-name {
        margin: 0px 0px 0 -32px;
    }

    .field-value {
        color: #000;
        font-size: 15px;
        font-weight: 500;
    }

    .cell-qty {
        color: #283891;
    }

    .cell-total {
        font-weight: 600;
        font-size: 15px;
    }

    .footer {
        text-align: right;
        margin: 14px 10px 0 0;
    }

    .total-content {
        margin-left: 20px;
        font-size: 22px;
        font-weight: 600;
    }

    .items-title {
        font-size: 20px;
    }

    .count-value {
        font-size: 20px;
    }

    .delete-item-icon {
        font-size: 18px;
        color: red;
        cursor: pointer;
    }

    .qty-field {
        width: 120px;
        height: 30px;
        margin: 10px 0 18px 0;
    }

    .payment-field {
        width: 120px;
    }

    /deep/ .qty-field > .v-input__control > .v-input__slot {
        min-height: 10px !important;
    }

    /deep/ .qty-field > .v-input__control > .v-input__slot > .v-input__prepend-inner > .v-input__icon > .v-icon {
        font-size: 18px;
        padding: 0 16px 4px 0;
    }

    .add-product-text {
        margin: 10px 0 0 16px;
        font-weight: 700;
        color: #3f51b5;
        cursor: pointer;
    }

    .price-summary {
        background: #f3f3f3;
        margin: 10px 10px -10px 10px;
    }

    .math-sign {
        float: right;
        font-size: 24px;
        margin: -10px 0 0 0;
    }

    .equal-sign {
        margin: -32px 0 0 0;
    }

    .value-field {
        font-size: 20px;
    }
</style>
